<template>
  <div class="popup-confirmation" v-if="open">
    <div class="box">
      <div class="content" :class="typeClass">
        <h4>
          <img class="icon" :src="publicImage('themes/elektramat/alert-circle-exc.svg')" alt="alert-circle"/>
          <span v-html="title"></span>
        </h4>

        <p v-html="content"></p>
      </div>
      <div class="actions">
        <button
            v-for="(a, index) in actions"
            :key="`action_${index}`"
            class="btn btn-primary btn-action"
            @click="$emit('action', a.type)"
            v-text="a.name"
        ></button>
      </div>
    </div>
    <div class="overlay" @click="$emit('close')"></div>
  </div>
</template>

<script>
export default {
  name: "PopupConfirm",
  data() {
    return {
      open: false,
      title: '',
      content: '',
      actions: [],
      type: 'warning',
    }
  },
  methods: {
    keyRelease(e) {
      if (this.open) {
        if (e.key === 'Escape') {
          this.$emit('close');
        }
      }
    },
  },
  computed: {
    typeClass() {
      return 'content-' + this.type;
    }
  },
  created() {
    window.addEventListener('keyup', this.keyRelease);
  },
  destroyed() {
    window.removeEventListener('keyup', this.keyRelease);
  },
}
</script>

<style scoped lang="scss">
.popup-confirmation {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;

  .overlay {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 3;
  }

  .box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #F9F9F9;
    z-index: 4;
    min-width: 40vw;
    width: 500px;
    max-width: calc(100vw - 36px);

    .content {
      padding: 20px;

      h4 {
        font-size: 18px;
        margin-bottom: 8px;
      }

      p {
        font-size: 12px;
      }

      .icon {
        margin-right: 8px;
      }

      &.content-warning {
        background: transparentize(#FF960A, 0.9);

        h4,
        p span {
          color: #FF960A
        }
      }

      &.content-alert {
        background: transparentize(#DC3545, 0.9);

        h4,
        p span {
          color: #DC3545
        }
      }
    }

    .actions {
      display: flex;
      justify-content: space-between;
      align-content: stretch;
      padding: 20px;

      .btn-action {
        height: 48px;
        width: 100%;
        text-transform: uppercase;
        font-size: 14px;

        background-color: #196CAE;
        border-color: #196CAE;
        border-radius: 0;

        &:nth-child(even) {
          background-color: transparentize(#196CAE, 0.5);
          border-color: transparentize(#196CAE, 0.5);
        }

        &:not(:last-child) {
          margin-right: 15px;
        }
      }
    }
  }
}
</style>
